import React, { useState, useEffect } from 'react';
import axios from 'axios';

// Create a self-fill EOI link and share it by hand (copy / WhatsApp on your own phone).
// kind 'client' (single use, 7 days) or 'broker' (reusable, 30 days).
const EOILinkShare = ({ apiBase, kind, clientId, clientName, onClose }) => {
  const [partners, setPartners] = useState([]);
  const [cpId, setCpId] = useState('');
  const [link, setLink] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (kind === 'broker') axios.get(`${apiBase}/booking-flow/brokers`).then((r) => setPartners(r.data || [])).catch(() => {});
  }, [apiBase, kind]);

  const create = async () => {
    if (kind === 'broker' && !cpId) { setErr('Pick the channel partner.'); return; }
    setBusy(true); setErr('');
    try {
      const r = await axios.post(`${apiBase}/public-eoi/links`, kind === 'broker' ? { kind, channel_partner_id: Number(cpId) } : { kind, client_id: clientId });
      setLink(r.data);
    } catch (e) { setErr(e.response?.status === 403 ? 'You are not allowed to create EOI links.' : (e.response?.data?.error || 'Could not create the link.')); }
    finally { setBusy(false); }
  };
  useEffect(() => { if (kind === 'client') create(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const who = kind === 'broker' ? (partners.find((p) => String(p.id) === String(cpId))?.name || 'partner') : clientName;
  const message = link && (kind === 'broker'
    ? `Hi ${who}, please use this link to fill the Expression of Interest for your clients at Kohinoor @ Patel Estate, Jogeshwari West. One form per client. Valid for 30 days:\n${link.url}`
    : `Dear ${who}, thank you for your interest in Kohinoor @ Patel Estate, Jogeshwari West. Please fill your Expression of Interest here (takes 3 minutes; you can add a photo of your cheque):\n${link.url}`);
  const copy = () => { navigator.clipboard?.writeText(message).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2500); }); };
  const wa = link && `https://wa.me/${link.share_to ? `91${link.share_to}` : ''}?text=${encodeURIComponent(message)}`;

  const btn = { width: '100%', padding: '14px', borderRadius: '12px', border: 'none', fontSize: '17px', fontWeight: 800, cursor: 'pointer', marginTop: '10px' };
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(17,24,39,.55)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '40px 12px', overflowY: 'auto' }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: '#fff', borderRadius: '16px', width: '100%', maxWidth: '480px', padding: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 800 }}>🔗 {kind === 'broker' ? 'Broker EOI link' : 'EOI link for the client'}</h2>
          <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '28px', cursor: 'pointer', color: '#6b7280' }} aria-label="Close">×</button>
        </div>
        <div style={{ fontSize: '14px', color: '#6b7280', marginTop: '4px' }}>
          {kind === 'broker' ? 'The partner fills one EOI per client. Reusable for 30 days.' : `${clientName} fills their own EOI. One use, valid 7 days.`}
        </div>

        {kind === 'broker' && !link && (
          <>
            <label style={{ display: 'block', fontSize: '14px', fontWeight: 700, margin: '14px 0 6px' }}>Channel partner</label>
            <select value={cpId} onChange={(e) => setCpId(e.target.value)} style={{ width: '100%', padding: '12px', border: '1.5px solid #d1d5db', borderRadius: '10px', fontSize: '16px' }}>
              <option value="">— pick —</option>
              {partners.map((p) => <option key={p.id} value={p.id}>{p.name}{p.firm ? ` · ${p.firm}` : ''}</option>)}
            </select>
            <button style={{ ...btn, background: '#2563eb', color: '#fff' }} disabled={busy} onClick={create}>{busy ? 'Creating…' : 'Create link'}</button>
          </>
        )}
        {kind === 'client' && !link && !err && <div style={{ padding: '16px 0', color: '#6b7280' }}>Creating the link…</div>}

        {link && (
          <>
            <div style={{ background: '#dcf8c6', borderRadius: '10px', padding: '12px', fontSize: '14px', whiteSpace: 'pre-wrap', marginTop: '14px', wordBreak: 'break-word' }}>{message}</div>
            <a href={wa} target="_blank" rel="noreferrer" style={{ ...btn, display: 'block', textAlign: 'center', textDecoration: 'none', background: '#25D366', color: '#fff' }}>Share on WhatsApp</a>
            <button style={{ ...btn, background: '#fff', border: '1px solid #d1d5db', color: '#111827', fontWeight: 700 }} onClick={copy}>{copied ? '✓ Copied' : 'Copy message'}</button>
            <div style={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center', marginTop: '8px' }}>WhatsApp opens on your phone — you press send. Nothing is sent automatically.</div>
          </>
        )}
        {err && <div style={{ background: '#fef2f2', color: '#b91c1c', padding: '10px 12px', borderRadius: '10px', fontSize: '14px', marginTop: '10px' }}>{err}</div>}
      </div>
    </div>
  );
};

export default EOILinkShare;
